import React, { useEffect } from 'react';
import {
    Button,
    Form,
    Input,
    Card,
    Select,
    Table,
    Row,
    DatePicker,
    Tag,
    Tooltip,
    Badge,
    Popconfirm,
} from 'antd';
import { services } from '@comall-backend-builder/core';

import './index.less';
import { errorHandle } from '../../services';
import { render } from 'react-dom';
const { Option } = Select;
const { RangePicker } = DatePicker;

const api = services.api;

export interface ExtendLabelRuleListViewProps {
    form: any;
}
const confirmProps = {
    title: '确定要删除吗？',
    okText: '确定',
    cancelText: '取消',
};
export interface IState {
    visible: boolean;
    black_remark: string;
    visibleClear: boolean;
    clearType: boolean;
    productModal: {
        visible: boolean;
        type: string;
    };
}
const labelStatus = [
    {
        label: '待生效',
        value: '1',
    },
    {
        label: '生效中',
        value: '0',
    },
    {
        label: '失效',
        value: '-1',
    },
];

// 商品经营管理
const ExtendLabelRuleListView = ({ form }: ExtendLabelRuleListViewProps) => {
    const [categoryCodeOptions, setCategoryCodeOptions] = React.useState([]);
    const [pageSize, setPageSize] = React.useState(10);
    const [pageNum, setPageNum] = React.useState(1);
    const [total, setTotal] = React.useState(0);
    const [tableData, setTableData] = React.useState([]);
    const [searchParams, setSearchParams] = React.useState({});
    const columns = [
        {
            title: '扩展标签规则ID',
            dataIndex: 'tagRuleCode',
            key: 'tagRuleCode',
            align: 'center' as const,
            width: 100,
            fixed: 'left' as const,
        },
        {
            title: '规则名称',
            dataIndex: 'tagRuleName',
            key: 'tagRuleName',
            align: 'center' as const,
            ellipsis: true,
            width: 190,
        },
        {
            title: '标签名称',
            dataIndex: 'tagNameList',
            key: 'tagNameList',
            align: 'center' as const,
            width: 400,
            render: (text: any) => {
                if (!text || text.length === 0) return null;
                const maxWidth = 250;
                let displayTags = [];
                let remainingCount = 0;
                let currentWidth = 0;

                // 简单估算每个标签的宽度（可以根据实际情况调整）
                for (let i = 0; i < text.length; i++) {
                    // 估算每个字符宽度为8px，加上padding和margin大约20px
                    const tagWidth = text[i].length * 8 + 20;

                    if (currentWidth + tagWidth <= maxWidth || i === 0) {
                        displayTags.push(
                            <Tag
                                key={text[i]}
                                color="blue"
                                style={{ marginRight: 8, marginBottom: 4 }}
                            >
                                {text[i]}
                            </Tag>
                        );
                        currentWidth += tagWidth;
                    } else {
                        remainingCount = text.length - i;
                        break;
                    }
                }

                return (
                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                        {displayTags}
                        {remainingCount > 0 && (
                            <Tooltip title={text.slice(text.length - remainingCount).join(', ')}>
                                <Tag color="blue" style={{ cursor: 'pointer' }}>
                                    +{remainingCount}
                                </Tag>
                            </Tooltip>
                        )}
                    </div>
                );
                // return text.map((d) => (
                //     <Tag key={d} color="blue">{d}</Tag>
                // ))
            },
        },
        {
            title: '标签有效期',
            dataIndex: 'configurationType',
            key: 'configurationType',
            align: 'center' as const,
            width: 250,
            render: (text: number, record: any) => {
                if (text === 0) return '永不失效';
                if (text === 1)
                    return (
                        <div>
                            <div>生效日期: {record.startEffectiveTime}</div>
                            <div>失效日期: {record.endEffectiveTime}</div>
                        </div>
                    );
            },
        },
        {
            title: '标签状态',
            width: 100,
            dataIndex: 'effectiveStatus',
            key: 'effectiveStatus',
            render: (text: number) => {
                return text === 0 ? (
                    <Badge status="success" text="生效中" />
                ) : text === 1 ? (
                    <Badge status="processing" text="待生效" />
                ) : (
                    <Badge status="error" text="失效" />
                );
            },
            align: 'center' as const,
        },
        {
            title: '执行状态',
            width: 100,
            dataIndex: 'processStatus',
            key: 'processStatus',
            render: (text: number) => {
                return text === 0 ? (
                    <Badge status="success" text="待处理" />
                ) : text === 1 ? (
                    <Badge status="error" text="处理中" />
                ) : (
                    <Badge status="processing" text="已处理" />
                );
            },
            align: 'center' as const,
        },
        {
            title: '更新人',
            dataIndex: 'updateByName',
            key: 'updateByName',
            width: 110,
            align: 'center' as const,
        },
        {
            title: '更新时间',
            dataIndex: 'updateTime',
            key: 'updateTime',
            align: 'center' as const,
            width: 170,
        },
        {
            title: '操作',
            align: 'center' as const,
            width: 170,
            fixed: 'right' as const,
            render: (_, record) => [
                <Button
                    size="small"
                    type="link"
                    onClick={() => {
                        services.navigation.goto(
                            `/product/extendLabelRule/detail/${record.tagRuleCode}`
                        );
                    }}
                >
                    查看
                </Button>,
                record.processStatus !== 1 && (
                    <Button
                        size="small"
                        type="link"
                        onClick={() => {
                            services.navigation.goto(
                                `/product/extendLabelRule/update/${record.tagRuleCode}`
                            );
                        }}
                    >
                        编辑
                    </Button>
                ),
                record.processStatus !== 1 && (
                    <Popconfirm
                        {...confirmProps}
                        onConfirm={() => {
                            api.get(
                                {},
                                { apiPath: `/searchTag/tagRuleDelete/${record.tagRuleCode}` }
                            )
                                .then((res: any) => {
                                    if (res && res.resultCode === 200) {
                                        getList({ page: 1, per_page: pageSize });
                                    }
                                })
                                .catch(errorHandle);
                        }}
                    >
                        <Button size="small" type="link">
                            删除
                        </Button>
                    </Popconfirm>
                ),
            ],
        },
    ];
    const getCategoryCodeOptions = () => {
        api.get({ attr_code: 'ZHPPL', page: 1, per_page: 9999 }, { apiPath: '/attributes/options' })
            .then((res: any) => {
                if (res && res.result) {
                    setCategoryCodeOptions(res.result);
                }
            })
            .catch(errorHandle);
    };
    const getList = (data) => {
        api.get(data, { apiPath: '/searchTag/tagRuleQueryPage?' })
            .then((res: any) => {
                if (res && res.result) {
                    setTableData(res.result);
                    setPageNum(res.page);
                    setTotal(res.totalNum);
                }
            })
            .catch(errorHandle);
    };
    const handleSubmit = () => {
        form.validateFields((err, values) => {
            if (!err) {
                const params = {
                    ...values,
                    page: 1,
                    per_page: pageSize,
                    startUpdateTime:
                        values.updateTime && values.updateTime[0]
                            ? values.updateTime[0].format('YYYY-MM-DD')
                            : undefined,
                    endUpdateTime:
                        values.updateTime && values.updateTime[1]
                            ? values.updateTime[1].format('YYYY-MM-DD')
                            : undefined,
                };
                delete params.updateTime;
                setSearchParams(params);
                getList(params);
            }
        });
    };
    useEffect(() => {
        getCategoryCodeOptions();
        getList({ page: 1, per_page: pageSize });
    }, []);
    return (
        <>
            <Card>
                <Row>
                    <Form
                        layout="inline"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                        }}
                    >
                        <Form.Item label="标签规则ID">
                            {form.getFieldDecorator(
                                'tagRuleCode',
                                {}
                            )(<Input placeholder="输入内容" />)}
                        </Form.Item>
                        <Form.Item label="规则名称">
                            {form.getFieldDecorator(
                                'tagRuleName',
                                {}
                            )(<Input placeholder="输入内容" />)}
                        </Form.Item>
                        <Form.Item label="标签状态">
                            {form.getFieldDecorator(
                                'effectiveStatus',
                                {}
                            )(
                                <Select
                                    placeholder="请选择"
                                    allowClear
                                    showSearch
                                    style={{ width: 250 }}
                                >
                                    {labelStatus.map((d) => (
                                        <Option key={d.value} value={d.value}>
                                            {d.label}
                                        </Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item label="更新人">
                            {form.getFieldDecorator(
                                'updateByName',
                                {}
                            )(<Input placeholder="输入内容" />)}
                        </Form.Item>
                        <Form.Item label="更新时间">
                            {form.getFieldDecorator(
                                'updateTime',
                                {}
                            )(<RangePicker placeholder={['开始时间', '结束时间']} />)}
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                style={{ marginRight: 8, marginBottom: 18 }}
                                htmlType="submit"
                            >
                                查询
                            </Button>
                            <Button onClick={() => form.resetFields()}>重置</Button>
                        </Form.Item>
                    </Form>
                </Row>
                <Row>
                    <Button
                        type="primary"
                        style={{ marginBottom: 18 }}
                        onClick={() => {
                            services.navigation.goto('/product/extendLabelRule/add');
                        }}
                    >
                        新增
                    </Button>
                </Row>
                <Table
                    columns={columns}
                    dataSource={tableData}
                    scroll={{ x: 1000 }}
                    pagination={{
                        total: total,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        pageSizeOptions: ['10', '15', '20'],
                        pageSize: pageSize,
                        current: pageNum,
                        showTotal: (total, range) => `共 ${total} 条记录`,
                        onChange: (page) => {
                            getList({ ...searchParams, page, per_page: pageSize });
                        },
                        onShowSizeChange: (current, size) => {
                            setPageSize(size);
                            getList({ ...searchParams, page: current, per_page: size });
                        },
                    }}
                />
            </Card>
        </>
    );
};

export const extendLabelRuleListView = Form.create()(ExtendLabelRuleListView);
